import { BasketService, NotificationService } from './api-service';
import { setBasketCount, setNotificationCount, setMaintenance } from './redux-store';

export const createTestId = (type = 'click', componentName, value = '') => {
  return `${type}-${componentName}${value ? `-${value}` : ''}`;
};

export const setDashboardCounts = async ({ count = null, type }) => {
  // type: 'notification', 'basket', 'all'

  const _setNotificationCount = async () => {
    const { isSuccess, data } = await new NotificationService().getNotificationCount();
    if (isSuccess) {
      console.log('_setNotificationCount data', data);
      setNotificationCount(data.count);
    }
  };

  const _setBasketCount = async () => {
    const { isSuccess, data } = await new BasketService().getBasketCount();
    if (isSuccess) {
      console.log('_setBasketCount data', data);
      setBasketCount(data.count);
    }
  };

  switch (type) {
    case 'notification':
      if (count >= 0) {
        setNotificationCount(count);
      } else {
        _setNotificationCount();
      }
      break;
    case 'basket':
      if (count >= 0) {
        setBasketCount(count);
      } else {
        _setBasketCount();
      }
      break;
    case 'all':
      _setNotificationCount();
      _setBasketCount();
      break;
    default:
      break;
  }
};

export const Maintenance = async status => {
  setMaintenance(status);
};

// adminden richtext olarak gelen alanin bos olup olmadigini kontrol eder
export const isRichTextEmpty = html => {
  if (!html || html.trim() === '') return true;
  const div = document.createElement('div');
  div.innerHTML = html;
  const text = div.textContent?.replace(/\u00A0/g, '').trim();
  return text.length === 0;
};

export const MOBILE_PHONE_REGEX = /^[1-9][0-9]{9}$/;

export const sanitizeMobilePhoneInput = value =>
  (value ?? '').replace(/\D/g, '').replace(/^0+/, '').slice(0, 10);

export const isValidMobilePhone = value => MOBILE_PHONE_REGEX.test(value ?? '');
